import type { JeevesPricingType } from '@/lib/services/Jeeves/pricing/getProductPricing'
import type { CustomerType } from '@/store/types/user'
import { mapCustomerType } from '@/lib/utils/user/mapCustomerType'

export const getTerms = ({
  forCustomerType,
  pricingData,
}: {
  forCustomerType: CustomerType
  pricingData: JeevesPricingType | null
}): JeevesPricingType['levels'][number]['terms'] | null => {
  // Map customer types using shared utility
  const correctedCustomerType = mapCustomerType(forCustomerType)

  const priceLevel = pricingData?.levels.find(
    (level) => level.customer === correctedCustomerType,
  )

  return priceLevel?.terms || null
}
